<template>
    <div>
        <div>
            <div class="banner"><el-carousel motion-blur>
                <el-carousel-item>
                    <a href="https://gkt.sceeic.cn/" target="_blank"><img  src="../img/151613_0673677da306b10260d029921312d4885ac.png"></a>
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../img/微信图片_20240315091147.png" >
                </el-carousel-item>
                <el-carousel-item>
                    <img src="..\img\微信截图_20250430162320.png" >
                </el-carousel-item>
            </el-carousel></div>
            <div class="information">
                <div class="policy"><hr><span class="left">政策信息</span><a href="/newlist/information" class="more">MORE+</a></div>
                <ul class="list" v-for="item in information" :key="item.id">
                    <li><a v-if="item.isLinkNews == 0" target="_blank" :href="url2 + information.indexOf(item)+ '/information/1'" :title="item.TITLE">{{ item.TITLE }}</a> <a v-if="item.isLinkNews != 0" target="_blank" :href="item.linkURL" :title="item.TITLE">{{ item.TITLE }}</a> </li><hr>
                </ul>
            </div>
        </div>
        <div>
            <div class="notice">
                <a href="/newlist/notice" class="title">公告公示</a><i class="cor"></i>
                <ul class="list2" v-for="item in notice" :key="item.id">
                    <li ><a v-if="item.isLinkNews == 0" target="_blank" :href="url2 + notice.indexOf(item) + '/notice/1'" class="content" :title="item.TITLE">{{ item.TITLE }}</a> <a v-if="item.isLinkNews != 0" target="_blank" :href="item.linkURL" class="content" :title="item.TITLE">{{ item.TITLE }}</a></li><span class="date">[{{ item.DATE.slice(0,10) }}]</span>
                </ul>
            </div>
            <div class="WXGZH">
                <div class="title1">微信公众号</div>
                <img src="../img/WXGZH.jpg">
            </div>
            <div class="WXSC">
                <div class="title1">微信书城</div>
                <img src="../img/WXSC.jpg">
            </div>
        </div>
        <div class="nav">
            <ul class="list3">
                <li id="高考资料"><el-button  size="large" type="primary" color="#e8f2ff" tag="a" href="/gkzl" @mouseenter="ChangeBookList('高考资料')"><el-icon  ><Coin /></el-icon>高考资料</el-button></li>
                <li id="自考教材"><el-button size="large" color="#e8f2ff"  tag="a" href="/zkjc" @mouseenter="ChangeBookList('自考教材')"><el-icon><Reading /></el-icon>自考教材</el-button></li>
                <li id="书法教材"><el-button size="large" color="#e8f2ff" tag="a" href="/sfjc" @mouseenter="ChangeBookList('书法教材')"><el-icon><EditPen /></el-icon>书法教材</el-button></li>
                <li id="报刊杂志"><el-button size="large" color="#e8f2ff" tag="a" href="/bkzz" @mouseenter="ChangeBookList('报刊杂志')"><el-icon><DocumentCopy /></el-icon>报刊杂志</el-button></li>
                <li id="特价图书"><el-button size="large" color="#e8f2ff" tag="a" href="/tjts" @mouseenter="ChangeBookList('特价图书')"><el-icon><CollectionTag /></el-icon>特价图书</el-button></li>
                <li id="成绩证书"><el-button size="large" color="#e8f2ff" tag="a" href="/cjzs" @mouseenter="ChangeBookList('成绩证书')"><el-icon><Notebook /></el-icon>成绩证书</el-button></li>
                <li id="其他"><el-button size="large" color="#e8f2ff" tag="a" href="/others" @mouseenter="ChangeBookList('其他')"><el-icon><Menu /></el-icon>其他</el-button></li>
            </ul>
        </div>
        <div class="book">
            <ul class="list4">
                <li v-for="item in books" :key="item.ID" >
                   <a @click="getBookId(item.ID)" > <div class="bookImg"><el-image v-if="item.IMG_COVER" :src="item.IMG_COVER[0]" /></div><p class="bookTitle">{{ item.NAME }}</p><p class="bookPrice"><span>￥</span>{{ item.PRICE }}</p></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Main",
        methods:{
            getBooks(){
                this.$axios.get('/api/Book/BookIndex').then(res=>{
                    res.data.图书信息.forEach(item=>{
                        item.IMG_COVER = item.IMG_COVER.split(',');
                    });
                    //只取公告公示中DATE的空格前的日期
                    res.data.公告公示.forEach(item=>{
                        item.DATE = item.DATE.split(' ')[0];
                    });
                    //只取前四个公告公示
                    this.notice = res.data.公告公示.slice(0,4);
                    this.information = res.data.政策信息;
                })
            },
            getBookId(id){
                let url = '/bookdetail/' + id;
                if (this.activeCategory === '成绩证书') {
                    url = '/cjzsdetail/' + id;
                }
                window.open(url);
            },
            ChangeBookList(category){
                this.activeCategory = category;
                var my = document.getElementById(category);
                var others = document.getElementsByClassName('list3');
                //将list3中所有的el-button的颜色改为#e8f2ff
                for(var i = 0; i < others.length; i++){
                    var other = others[i].getElementsByClassName('el-button');
                    for(var j = 0; j < other.length; j++){
                        //将el-button的background清除
                        other[j].style.background = '';
                        other[j].style.color = '#000';
                        other[j].style.backgroundColor = '#e8f2ff';
                        //将el-button中的el-icon的颜色改为#49aef1
                        var icon = other[j].getElementsByClassName('el-icon');
                        icon[0].style.color = '#49aef1';
                    }
                }
                //将当前el-button的颜色改为#47a8f3
                var button = my.getElementsByClassName('el-button');
                button[0].style.background = 'linear-gradient(to top, #47a8f3,#6ac7f8)';
                button[0].style.color = '#ffffff';
                //将el-button中的el-icon的颜色改为#ffffff
                var icon1 = button[0].getElementsByClassName('el-icon');
                icon1[0].style.color = '#ffffff';
                this.$axios.post('/api/Book/Booklist',{
                    category: category
                }).then(res=>{
                    res.data.hot.forEach(item=>{
                        item.IMG_COVER = item.IMG_COVER.split(',');
                    });
                    this.books = res.data.hot;
                })
            }
        },
        data(){
            return{
                books:[],
                activeCategory: '高考资料',
                url2: '/newdetail/',
                notice:[],
                information:[]
            }
        },
        created(){
            this.getBooks();
        },
        mounted(){
            this.ChangeBookList('高考资料')
        }

    }
</script>

<style scoped>
.list4 li a{
    text-decoration: none;
    color: #464545;
}
.list4 li:hover{
    box-shadow: 0 0 10px #ccc;
}
.list4 li:hover .bookImg{
    border: rgb(204, 199, 199);
}
.bookPrice{
    margin-top: 20px;
    color: #db444a;
    font-size: 25px;
    font-weight: bold;
    margin-right: 50px;
}
.bookPrice span{
    font-size: 16px;
    font-weight: bold;
}
.bookTitle{
    width: 210px;
    height: 40px;
    margin-top: 20px;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.bookImg{
    width: 220px;
    height: 230px;
    border: rgb(204, 199, 199) solid 1px;
    border-radius: 6px;
}
.list4{
    list-style-type: none;
    float: left;
    margin-left: 225px;
    margin-top: 20px;
    height: 400px;
}
.list4 li{
    float: left;
    width: 270px;
    height: 380px;
    padding-left: 25px;
    margin-top: 20px;
    border-radius: 6px;
}
.list4 .el-image{
    width: 150px;
    height: 190px;
    margin-top: 20px;
}
.el-icon{
    font-size: 25px;
    margin-right: 10px;
    color: #49aef1;
}

.el-button{
    width: 187px;
    height: 46px;
    font-size: 16px;
    border-radius: 7px;
    margin-top: 1px;
}
.list3 .el-button{
    width: 161px;
    padding-left: 10px;
}
.list3 {
    list-style-type: none;
    float: left;
    margin-left: 240px;
    margin-top: 5px;
    height: 60px;
}

.list3 li {
    float: left;
    font-size: 20px;
    margin-left: 20px;
    width: 165px;
    height: 50px;
    font-weight: bold;
    border-radius: 7px;
    display: block;
    color: #49aef1;
    border: #c3d1db solid 1px;
}

.WXSC {
    width: 190px;
    height: 190px;
    float: left;
    margin-left: 20px;
}
.WXSC{
    width: 190px;
    height: 190px;
    float: left;
    margin-left: 20px;
    border-radius: 4px;
    margin-top: 20px;
    border: rgb(204, 199, 199) solid 1px;
}
.WXSC img{
    width: 110px;
    height: 110px;
    margin-top: 20px;
}
.title1{
    width: 190px;
    height: 40px;
    background-color: #84a2bb;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    padding-top: 10px;
}
.WXGZH{
    width: 190px;
    height: 190px;
    float: left;
    margin-left: 20px;
    border-radius: 4px;
    margin-top: 20px;
    border: rgb(204, 199, 199) solid 1px;
}
.WXGZH img{
    width: 110px;
    height: 110px;
    margin-top: 20px;
}
.date{
    float: right;
    margin-right: -60px;
    margin-top: -20px;
    font-size: 14px;
    color: #7c858c;
}
.content{
    color: #464545;
    text-align: left;
    margin-left: -10px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.list2{
    float: left;
    margin-left: 10px;
    margin-top: 12px;
    text-align: left;
    width: 700px;
    list-style-position: inside;
    white-space: nowrap;
}
.list2 li{
    margin-top: 5px;
    font-size: 16px;
    width: 600px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 10px;
}
.list2 li::marker{
    color: rgb(82, 183, 241);
    font-size: 20px;
}
.title {
    height: 190px;
    width: 60px;
    background-color: #d54545;
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    border-radius: 4px;
    display: flex;
    float: left;
    justify-content: center;
    align-items: center;
    writing-mode: vertical-rl;
}
.cor{
    float: left;
    width: 0;
    height: 0;
    margin-top: 90px;
    margin-bottom: 90px;
    border: 10px solid ;
    border-color: transparent transparent transparent  #d54545;
}
.notice{
    width: 877px;
    height: 190px;
    float: left;
    margin-left: 250px;
    border: rgb(204, 199, 199) solid 1px;
    background-color: #f5f6f6;
    border-radius: 6px;
    margin-top: 20px;
}


 .banner{
     width: 882px;
     height: 302px;
     float: left;
     margin-left: 250px;
 }
 .el-carousel {
        width: 882px;
        height: 302px;
 }
 .el-carousel-item {
        width: 882px;
        height: 302px;
 }
 .banner img{
    height: 302px;
 }
img{
    border-radius: 6px;
}
 .list{
    list-style-type: none;
    white-space: nowrap;
    float: left;
    text-align: left;
 }
li{
        margin-top: 18px;
        font-size: 16px;
        width: 380px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
 }
 .left{
     float: left;
     margin-left: 20px;
     font-size: 20px;
     font-weight: bold;
     margin-top: 10px;
     color: #49aef1;
 }
 .more{
     float: right;
     margin-right: 20px;
     font-size: 15px;
     margin-top: 10px;
 }
 .information{
     width: 300px;
     height: 300px;
     float: left;
     margin-left: 20px;
     clear:right;
 }
 .policy{
     width: 400px;
     height: 50px;
     float: left;
     display: block;
     background-color: #cee8fa;
     border-radius: 6px;
 }
 .list a{
    margin-left: 20px;
 }
 a{
    color: #464545;
    text-decoration: none;
}
a:hover{
    color: #49aef1;
}
hr:first-child{
    height: 3px;
    border: none;
    background-color: #49aef1;
}
hr:nth-child(2){
    height: 1px;
    margin-top: 10px;
    border: none;
    width: 400px;
    background-color: rgb(204, 199, 199);
}
</style>
